import React from 'react';
import styled from 'styled-components';
import { Typography } from 'design-component';
import { Link } from 'react-router';
import { palette } from 'styles/color';
import ImgSection2 from 'assets/img/home_s2.svg';
import ImgSection3 from 'assets/img/home_s3.svg';
import ImgSection4 from 'assets/img/home_s4.svg';
import Feature1 from 'assets/img/feature1.svg';
import Feature2 from 'assets/img/feature2.svg';
import Feature3 from 'assets/img/feature3.svg';
import Feature4 from 'assets/img/feature4.svg';
import { IconPhone, IconMail, IconPlus, IconCheck } from 'assets/icon';
import { LANG_KO_KR, LANG_EN_US } from 'locale';
import { useTranslation } from 'react-i18next';
import TooltipMenu from 'components/TooltipMenu';

export default function Home() {
  return (
    <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
    </div>
  );
}

const Section1 = () => {
  const { t } = useTranslation();

  return (
    <Section1Wrapper height={686}>
      <Wrapper direction="column" contentAlign="center">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <Typography
            color={palette.white}
            size="22px"
            weight={500}
            height="150%"
            align="center"
            style={{ letterSpacing: '-0.26px' }}>
            {t('home.header.subTitle')}
          </Typography>
          <Typography
            component="h2"
            color={palette.white}
            size="50px"
            weight={700}
            height="120%"
            align="center">
            {t('home.header.title')}
          </Typography>
          <Typography
            color={'#E7E7E7'}
            size="18px"
            weight={500}
            height="180%"
            align="center"
            style={{ letterSpacing: '-0.26px' }}>
            {t('home.header.desc1')}
            <br />
            {t('home.header.desc2')}
          </Typography>
          <ButtonGroup />
        </div>
      </Wrapper>
    </Section1Wrapper>
  );
};

const Section2 = () => {
  const { t } = useTranslation();

  return (
    <Section height={600}>
      <Wrapper direction="row" contentAlign="space-between">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8
          }}>
          <Typography
            component="h2"
            size="34px"
            weight={700}
            height="45px"
            color="#26282B"
            style={{ letterSpacing: '-0.3px' }}>
            {t('home.features.feat1.title')}
          </Typography>
          <Typography
            component="h2"
            size="16px"
            weight={400}
            color="#454C53"
            style={{ letterSpacing: '-0.3px' }}>
            {t('home.features.feat1.desc1')}
            <br />
            {t('home.features.feat1.desc2')}
          </Typography>
        </div>
        <img src={ImgSection2} alt="DataInsight Section 2" />
      </Wrapper>
    </Section>
  );
};

const Section3 = () => {
  const { t } = useTranslation();

  return (
    <Section height={600} bgcolor="#E6EEFF">
      <Wrapper direction="row" contentAlign="space-between">
        <img src={ImgSection3} alt="DataInsight Section 3" />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8
          }}>
          <Typography
            component="h2"
            size="34px"
            weight={700}
            height="51px"
            color="#26282B"
            align="right"
            style={{ letterSpacing: '-0.3px' }}>
            {t('home.features.feat2.title1')}
            <br />
            {t('home.features.feat2.title2')}
          </Typography>
          <Typography
            component="h2"
            size="16px"
            weight={400}
            color="#454C53"
            align="right"
            style={{ letterSpacing: '-0.3px' }}>
            {t('home.features.feat2.desc1')}
            <br />
            {t('home.features.feat2.desc2')}
          </Typography>
        </div>
      </Wrapper>
    </Section>
  );
};

const Section4 = () => {
  const { t } = useTranslation();

  return (
    <Section height={600}>
      <Wrapper direction="row" contentAlign="space-between">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8
          }}>
          <Typography
            component="h2"
            size="34px"
            weight={700}
            height="51px"
            color="#26282B"
            style={{ letterSpacing: '-0.3px' }}>
            {t('home.features.feat3.title1')}
            <br />
            {t('home.features.feat3.title2')}
          </Typography>
          <Typography
            component="h2"
            size="16px"
            weight={400}
            color="#454C53"
            style={{ letterSpacing: '-0.3px' }}>
            {t('home.features.feat3.desc1')}
            <br />
            {t('home.features.feat3.desc2')}
          </Typography>
        </div>
        <img src={ImgSection4} alt="DataInsight Section 4" />
      </Wrapper>
    </Section>
  );
};

const Section5 = () => {
  const { t } = useTranslation();
  const features = [
    {
      id: 1,
      thumb: <img src={Feature1} alt="Feature 1" />,
      subtitle: `${t('home.mainFeatures.item1.subtitle')}`,
      title: `${t('home.mainFeatures.item1.title')}`,
      description: [
        `${t('home.mainFeatures.item1.detail1')}`,
        `${t('home.mainFeatures.item1.detail2')}`,
        `${t('home.mainFeatures.item1.detail3')}`
      ]
    },
    {
      id: 2,
      thumb: <img src={Feature2} alt="Feature 2" />,
      subtitle: `${t('home.mainFeatures.item2.subtitle')}`,
      title: `${t('home.mainFeatures.item2.title')}`,
      description: [
        `${t('home.mainFeatures.item2.detail1')}`,
        `${t('home.mainFeatures.item2.detail2')}`,
        `${t('home.mainFeatures.item2.detail3')}`
      ]
    },
    {
      id: 3,
      thumb: <img src={Feature3} alt="Feature 3" />,
      subtitle: `${t('home.mainFeatures.item3.subtitle')}`,
      title: `${t('home.mainFeatures.item3.title')}`,
      description: [
        `${t('home.mainFeatures.item3.detail1')}`,
        `${t('home.mainFeatures.item3.detail2')}`,
        `${t('home.mainFeatures.item3.detail3')}`
      ]
    },
    {
      id: 4,
      thumb: <img src={Feature4} alt="Feature 4" />,
      subtitle: `${t('home.mainFeatures.item4.subtitle')}`,
      title: `${t('home.mainFeatures.item4.title')}`,
      description: [
        `${t('home.mainFeatures.item4.detail1')}`,
        `${t('home.mainFeatures.item4.detail2')}`,
        `${t('home.mainFeatures.item4.detail3')}`
      ]
    }
  ];
  return (
    <Section height={880} bgcolor="#E6EEFF">
      <Wrapper direction="column" contentAlign="center">
        <Typography
          size="20px"
          weight={700}
          height="170%"
          color={palette.blue[500]}
          style={{ letterSpacing: '-0.26px' }}>
          {t('home.mainFeatures.subtitle')}
        </Typography>
        <Typography
          component="h2"
          size="36px"
          weight={700}
          height="170%"
          color="#0B3263"
          style={{ letterSpacing: '-0.26px', margin: '4px 0 20px 0' }}>
          {t('home.mainFeatures.title')}
          <br />
        </Typography>
        <ButtonGroup />
        <FeatureGrid>
          {features.map((feature) => (
            <FeatureBlock key={feature.id}>
              {feature.thumb}
              <Typography
                size="14px"
                weight={500}
                height="22px"
                color={palette.gray[500]}
                align="center"
                style={{ letterSpacing: '-2%', marginTop: 15 }}>
                {feature.subtitle}
              </Typography>
              <Typography
                component="h3"
                size="22px"
                weight={700}
                height="32px"
                color={palette.black}
                align="center"
                style={{ letterSpacing: '-1%', marginBottom: 13, whiteSpace: 'pre' }}>
                {feature.title}
              </Typography>
              {feature.description.map((desc, index) => (
                <Typography
                  key={index}
                  size="16px"
                  weight={400}
                  height="24px"
                  color={palette.gray[900]}
                  align="center"
                  style={{ letterSpacing: '-2%', marginBottom: 6 }}>
                  {desc}
                </Typography>
              ))}
            </FeatureBlock>
          ))}
        </FeatureGrid>
      </Wrapper>
    </Section>
  );
};

const Section6 = () => {
  const { t } = useTranslation();

  return (
    <Section6Wrapper height={320}>
      <Wrapper direction="row" contentAlign="space-between">
        <Typography component="h2" size="40px" weight={700} height="150%" color={palette.white}>
          {t('home.footer.title1')}
          <br />
          {t('home.footer.title2')}
        </Typography>
        <ButtonGroup />
      </Wrapper>
    </Section6Wrapper>
  );
};

const Section7 = ({}: // language,
// onLanguageChange
{
  // language: string;
  // onLanguageChange: (arg: 'ko' | 'en') => void;
}) => {
  const { t } = useTranslation();
  const contactText = t('home.footer.contact', { defaultValue: '' });

  return (
    <Footer>
      <div>
        <Typography weight={600} size="15px" height="100%" style={{ marginBottom: 28 }}>
          Polaris Office Corp.
        </Typography>
        <Typography
          component="div"
          weight={400}
          size="13px"
          height="22px"
          color="#565656"
          style={{
            marginBottom: 18
          }}>
          {t('home.footer.businessNumber')} : 220-81-43747{' '}
          <a
            href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208143747"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none', display: 'inline' }}>
            <Typography
              component="span"
              weight={400}
              size="13px"
              height="22px"
              color={palette.blue[500]}
              style={{
                textDecoration: 'underline'
              }}>
              {t('home.footer.businessInfo')}
            </Typography>
          </a>{' '}
          | {t('home.footer.privacyOfficer')}
          <br />
          {t('home.footer.salesReport')}
          <br />
          {t('home.footer.address')}
        </Typography>

        {contactText && (
          <div style={{ display: 'flex', gap: 12, marginBottom: 8 }}>
            <IconPhone
              style={{
                color: '#787878'
              }}
            />
            <Typography weight={400} size="13px" height="22px" color="#565656">
              {contactText}
            </Typography>
          </div>
        )}

        <div style={{ display: 'flex', gap: 12 }}>
          <IconMail
            style={{
              color: '#787878'
            }}
          />
          <Typography weight={400} size="13px" height="22px" color="#565656">
            support@polarisoffice.com
          </Typography>
        </div>

        <Typography
          weight={400}
          size="12px"
          height="20px"
          color="#565656"
          style={{ marginTop: 38 }}>
          Copyright Polaris Office Corp. All Rights Reserved
        </Typography>
      </div>

      {/* <LanguageSelect value={language} onChange={onLanguageChange} /> */}
    </Footer>
  );
};

const ButtonGroup = () => {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'center' }}>
      <InquiryButton
        onClick={() =>
          window.open(
            'https://polarisofficehelp.zendesk.com/hc/ko/requests/new?ticket_form_id=360011205956'
          )
        }
        to={'/'}>
        {t('home.button.contactUs')}
      </InquiryButton>
      <TryButton to={'/playground/doc-extract'}>{t('home.button.tryNow')}</TryButton>
    </div>
  );
};

export const LanguageSelect = ({
  value,
  onChange,
  position = 'top'
}: {
  value: string;
  onChange: (lang: 'ko' | 'en') => void;
  position?: 'top' | 'bottom';
}) => {
  const { t } = useTranslation();
  return (
    <TooltipMenu
      position={position}
      opener={
        <button
          color="primary"
          style={{
            background: 'rgba(243, 243, 243, 1)',
            border: 'none',
            padding: '13px 14px',
            width: '152px',
            // height: '40px',
            boxSizing: 'border-box',
            borderRadius: '8px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
          <Typography component="div" size="12px" weight={400} height="100%" color={palette.black}>
            {t('languageSelection')}
          </Typography>
          <IconPlus
            style={{
              color: '#787878',
              padding: '8px 15px !important'
            }}
          />
        </button>
      }
      onOpen={() => {}}>
      <TooltipMenu.MenuItem onClick={() => onChange(LANG_KO_KR)}>
        <SelectItem isActive={value === LANG_KO_KR}>한국어</SelectItem>
      </TooltipMenu.MenuItem>
      <TooltipMenu.MenuItem onClick={() => onChange(LANG_EN_US)}>
        <SelectItem isActive={value === LANG_EN_US}>ENGLISH</SelectItem>
      </TooltipMenu.MenuItem>
    </TooltipMenu>
  );
};

const SelectItem = ({
  children,
  style,
  isActive = false
}: {
  children: React.ReactNode;
  style?: React.CSSProperties;
  isActive?: boolean;
}) => {
  return (
    <SelectItemBase style={style} isActive={isActive}>
      {isActive ? (
        <IconCheck
          style={{
            color: palette.blue[500],
            marginRight: 6
          }}
        />
      ) : (
        <div style={{ width: 24 }} />
      )}

      <Typography
        component="div"
        size="12px"
        weight={400}
        height="30px"
        color={isActive ? palette.blue[500] : palette.black}
        style={{ marginLeft: 6 }}>
        {children}
      </Typography>
    </SelectItemBase>
  );
};

const SelectItemBase = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isActive'
})<{ isActive?: boolean }>`
  width: 130px;
  box-shadow: none !important;
  color: ${({ isActive }) => (isActive ? '#1F8AFA' : palette.black)};
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 5px;

  &:hover {
    background: none !important;
  }
`;

// 버튼 공통
const Button = styled(Link)<{ primary?: boolean }>`
  border: none;
  padding: 17px 43px;
  border-radius: 30px;
  cursor: pointer;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;

  &:hover {
    transition: background-color 0.3s ease;
  }
`;

// 문의하기 버튼
const InquiryButton = styled(Button)`
  background: ${palette.white};
  color: ${palette.black};

  &:hover {
    background: #c2c6cb;
  }
`;

// 지금 사용해보기 버튼
const TryButton = styled(Button)`
  background: ${palette.blue[500]};
  color: ${palette.white};

  &:hover {
    background: #1a5ec6;
  }
`;

const Section = styled.section.withConfig({
  shouldForwardProp: (prop) => !['height', 'bgcolor'].includes(prop)
})<{ height: number; bgcolor?: string }>`
  background-color: ${({ bgcolor }) => bgcolor || '#fff'};
  width: 100%;
  height: ${({ height }) => height}px;
`;

const Wrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['direction', 'contentAlign'].includes(prop)
})<{
  direction: 'row' | 'column';
  contentAlign: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around';
}>`
  max-width: 1308px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: center;
  justify-content: ${({ contentAlign }) => contentAlign || 'center'};
`;

const Section1Wrapper = styled(Section)`
  position: relative;
  background: url('/images/home_bg.jpg') no-repeat center center;
  background-size: cover;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(8, 30, 54, 0.35);
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }
`;

// Section 5
const FeatureBlock = styled.div`
  text-align: center;
  width: 22%;
  min-width: 312px;
  height: 342px;
  padding: 38px 20px 48px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 0px 20px 0px #829dd50d;
  border: 1px solid #e6e6e6;
  border-radius: 20px;
`;

const FeatureGrid = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  margin-top: 40px;
`;

const Section6Wrapper = styled(Section)`
  background: url('/images/home_footer.png') no-repeat center center;
  background-color: #1e3671;
`;

const Footer = styled.footer`
  width: calc(100% - 620px);
  max-width: 1280px;
  margin: 0 auto;
  padding-top: 60px;
  box-sizing: border-box;
  height: 360px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border-top: 1px solid #ccc;
`;
